import React, { useContext, useEffect, useMemo, useState } from 'react';
import './topbar.css';
import topbarImg from './BlueTopbar2.png';
import EventsContext from '../EventsContext';

const fallbackMessages = [{ type: 'critical', text: 'CRITICAL: NOT CONNECTED TO EVENTS!' }];

const TopBar = () => {
    const { events } = useContext(EventsContext) || {};
    const feed = useMemo(
        () => (Array.isArray(events) && events.length > 0 ? events : fallbackMessages),
        [events]
    );
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        if (feed.length === 0) return;
        const t = setInterval(() => setIdx(p => (p + 1) % feed.length), 7000);
        return () => clearInterval(t);
    }, [feed.length]);

    useEffect(() => { setIdx(0); }, [feed.length]);

    const current = feed[idx] || { type: 'normal', text: '' };

    return (
        <div className="topbar">
            <img src={topbarImg} alt="Top Bar" />
            {/* the pulse overlay (must be in DOM) */}
            <div className="topbar-pulse" aria-hidden="true" />
            <div className="topbar-system-notifications">
                <span className={`notification-message ${current.type}`}>{current.text}</span>
            </div>
        </div>
    );
};

export default TopBar;
